import React from "react";
import TextField from "@mui/material/TextField";

const Field = ({ label, required, id, value, onChange, multiline,isDisabled,error }) => {
  return (
    <div style={{ marginBottom: 22,opacity: isDisabled ? 0.5 : 1,
          pointerEvents: isDisabled ? "none" : "auto",
          transition: "opacity 0.3s ease", }}>
      <TextField
        id={id}
        label={
          <span>
            {label}
            {required && (
              <span style={{ color: "#d93025", marginLeft: 2 }}>*</span>
            )}
          </span>
        }
        value={value}
        onChange={(e) => onChange(e.target.value)}
        multiline={multiline}
        rows={multiline ? 2 : undefined}
        fullWidth
        variant="outlined"
        size="small"
        sx={{
          "& .MuiInputBase-root": {
            fontSize: 13,
            background: "#fafaf9",
            borderRadius: "8px",
            fontFamily: "inherit",
            color: "#1a1a1a",
          },
          "& .MuiInputBase-input": {
            padding: "8px 11px",
          },
          "& .MuiOutlinedInput-notchedOutline": {
            borderColor: "#e0ddd8",
            borderRadius: "8px",
          },
          "&:hover .MuiOutlinedInput-notchedOutline": {
            // borderColor: "#e0ddd8",
            borderColor: "#5CC7C1 !important",
          },
          "& .Mui-focused .MuiOutlinedInput-notchedOutline": {
            borderColor: "#5CC7C1 !important",
            borderWidth:'1px !important',
          },
          "& .MuiInputLabel-root": {
            fontSize: 11.5,
            fontWeight: 500,
            color: "#6b6b6b",
            letterSpacing: "0.01em",
          },
          "& .MuiInputLabel-root.Mui-focused": {
            color: "#5CC7C1",
          },
        }}
      />
      <span style={{fontSize:'11px',color:'red'}}>{error}</span>
    </div>
  );
};

export default Field;
